import React from 'react';
import { Link } from 'gatsby';
import {
  Content,
  Container,
  ActionIcon,
  Logo,
} from '../../../pages/register/styles';
import Button from '../../Button';
import { useRegister } from '../../../hooks/register';
import { BgImage } from '../../Sections/InfoSection/styles';

const RegisterError: React.FC = () => {
  const { handleStep, clearData } = useRegister();

  const restart = () => {
    clearData();
    handleStep('registerForm');
  };

  return (
    <>
      <BgImage image="img/signup-bg.svg" right="0px" top="0px" width={203} height={50} />
      <BgImage image="img/signup-bg7.svg" left="0px" top="0px" width={130} height={130} showOnMobile />
      <BgImage image="img/signup-bg3.svg" right={77} top={150} width={49} height={48} />
      <BgImage image="img/signup-bg5.svg" right="0px" bottom="0px" width={131} height={130} />
      <BgImage image="img/signup-bg2.svg" right={130} bottom={160} width={114} height={80} />
      <BgImage image="img/signup-bg6.svg" left="0px" bottom="0px" width={283} height={97} />
      <BgImage image="img/signup-bg4.svg" left={119} bottom={153} width={204} height={165} />

      <Content>
        <Container>
          <Link to="/">
            <Logo src={`img/logo-allya.svg`} alt="allya" />
          </Link>
          <ActionIcon src={`img/sad_face.svg`} alt="allya" />
          <h1>Não foi possível iniciar seu cadastro</h1>
          <h2>
            Um problema ocorreu e seu cadastro não foi realizado. Por favor, tente novamente. Se o problema persistir,
            entre em contato com o RH/Reponsável da sua empresa.
          </h2>

          <Button
            onClick={restart}
            title="Tentar novamente"
            width={324}
            classType="big fat orange center"
            type="button"
          />
        </Container>
      </Content>
    </>
  );
};

export default RegisterError;
